import { UserService } from '@/services/UserService';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import HeaderSpace from '../common/header-space/HeaderSpace';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    password: '',
    confirm_password: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState({
    password_required: '',
    password: '',
    confirm_password_required: '',
    confirm_password: '',
  });
  const [isFormValid, setIsFormValid] = useState(false);
  const [token, setToken] = useState<string>('');
  const [restaurantId, setRestaurantId] = useState<string>('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value?.trim() || '' });
  };

  const handleValidation = useCallback(() => {
    let flag = true;
    const error = {
      password_required: '',
      password: '',
      confirm_password_required: '',
      confirm_password: '',
    };

    if (!formData.password) {
      error.password_required = 'Password is required';
      flag = false;
    } else if (formData.password.length < 6) {
      error.password = 'Password must be at least 6 characters long';
      flag = false;
    }
    if (!formData.confirm_password) {
      error.confirm_password_required = 'Confirm Password is required';
      flag = false;
    } else if (formData.password !== formData.confirm_password) {
      error.confirm_password = 'Passwords do not match';
      flag = false;
    }
    setError(error);
    setIsFormValid(flag);
  }, [formData]);

  useEffect(() => {
    const token = searchParams.get('token');
    const restaurantId = searchParams.get('restaurant_id');
    if (token && restaurantId) {
      setToken(token);
      setRestaurantId(restaurantId);
      UserService.verifyResetPasswordToken(token, restaurantId)
        .then((res) => {
          if (res?.data?.status !== 'success') {
            navigate('/');
          }
        })
        .catch((err) => {
          setTimeout(() => {
            navigate('/');
          }, 3000);
        });
    } else {
      navigate('/');
    }
  }, [navigate, searchParams]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
    handleValidation();
    if (isFormValid) {
      setLoading(true);
      UserService.resetPassword(token, restaurantId, formData.password)
        .then((res) => {
          setLoading(false);
          setFormData({
            password: '',
            confirm_password: '',
          });
          setTimeout(() => {
            navigate('/');
          }, 3000);
        })
        .catch((err) => {
          setLoading(false);
          setTimeout(() => {
            navigate('/');
          }, 3000);
        });
    }
  };

  useEffect(() => {
    handleValidation();
  }, [handleValidation, formData.password, formData.confirm_password]);

  return (
    <div className="login-section">
      <HeaderSpace />
      <div className="cs-container">
        <div className="auth-container login-content">
          <div className="login-header">
            <h1>Reset Password</h1>
          </div>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="grid grid--1">
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="form-field">
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className={
                      submitted && (error.password_required || error.password)
                        ? 'error'
                        : ''
                    }
                  />
                  {submitted && error.password && (
                    <span className="error-message">{error.password}</span>
                  )}
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="confirm_password">Confirm Password</label>
                <div className="form-field">
                  <input
                    type="password"
                    id="confirm_password"
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleInputChange}
                    className={
                      submitted &&
                      (error.confirm_password_required ||
                        error.confirm_password)
                        ? 'error'
                        : ''
                    }
                  />
                  {submitted && error.confirm_password && (
                    <span className="error-message">
                      {error.confirm_password}
                    </span>
                  )}
                </div>
              </div>
              <div className="form-options"></div>
            </div>
            <div className="buttons-group justify-center">
              <button className="btn btn--pri" type="submit" disabled={loading}>
                Submit
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
